import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LabService } from '../lab.service';
import { DetectedObject } from '../types/bounding-box.model';
import { ProcessedImage } from '../types/lab.types';

@Component({
  selector: 'nw-lab-processed',
  templateUrl: './processed.component.html',
  styleUrls: ['./processed.component.scss'],
})
export class LabProcessedComponent implements OnInit {
  imageFile!: File;
  imageUrl!: string;
  loading = false;
  processedImages: ProcessedImage[] = [];
  detectedObjects: DetectedObject[] = [];
  customDetectedObjects: DetectedObject[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  labelCount: { [label: string]: number } = {};
  selectedImage: ProcessedImage;

  constructor(private lab: LabService) {}

  async ngOnInit(): Promise<void> {
    this.processedImages = await this.lab.getProcessedImages();
    console.log({ processed: this.processedImages });
  }

  async loadFile(file: ProcessedImage) {
    this.selectedImage = file;
    const [modelResult] = await this.lab.getBoxes(file.modelDetection);

    console.log({ modelResult });
    this.detectedObjects = modelResult?.boxes || [];

    if (file.customDetection) {
      const [customResult] = await this.lab.getBoxes(file.customDetection);

      console.log({ customResult });
      this.customDetectedObjects = customResult?.boxes || [];
    }

    this.updateLabelCount();
    this.loading = false;
  }

  updateLabelCount(): void {
    this.labelCount = this.detectedObjects.reduce(
      (acc, obj) => {
        acc[obj.label] = (acc[obj.label] || 0) + 1;
        return acc;
      },
      {} as { [label: string]: number },
    );
  }

  async saveCustomDetection(customDetection: DetectedObject[]): Promise<void> {
    console.log({ customDetection });

    if (!this.selectedImage.id) {
      return;
    }

    await this.lab.saveCustomDetection(this.selectedImage.id, customDetection);
  }

  stringify(objects: DetectedObject[]): string {
    return JSON.stringify(objects, null, 2);
  }
}
